import {dateEnTexte} from 'ff-common';
import {Text} from '@chakra-ui/react';
import {Trans, useTranslation} from 'react-i18next';

export const CommandeDateTexte: React.FC<{
  date_de_livraison: string;
  color: string;
  fontSize: string | Record<string, string>;
}> = ({date_de_livraison, color, fontSize}) => {
  const {t} = useTranslation();
  return (
    <Text
      color={color}
      fontSize={fontSize}
      fontStyle='normal'
      fontWeight={400}
    >
      <Trans
        t={t}
        i18nKey='header_band.temps_restant'
        values={{date_de_livraison: dateEnTexte(date_de_livraison)}}
        components={{
          Text: (
            <Text
              as='strong'
              fontWeight={700}
              wordBreak='keep-all'
              whiteSpace='nowrap'
            />
          ),
        }}
      />
    </Text>
  );
};
